/* eslint-disable @next/next/no-img-element */
import React from "react";

import styles from "./styles.module.scss";

interface TextLayoutProps {
	header: string;
	text: string | JSX.Element;
	img?: string;
	className?: string;
	isGreyHeader?: boolean;
}

export default function TextLayout({ header, text, img, className, isGreyHeader }: TextLayoutProps) {
	return (
		<div className={`${styles.container} ${className}`}>
			<div className={styles.line}></div>

			<div className={styles.content}>
				<h2 className={`${styles.header} ${isGreyHeader ? styles.boi : ""}`}>{header}</h2>
				<p className={styles.text}>{text}</p>
				{!!img && <img className={styles.img} src={img} alt={header} />}
			</div>
		</div>
	);
}
